import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import { getClassFlagOptions } from '../helpers';

import type { ClassFlags, FormState } from '../types';

interface Props {
  customField: FormState;
  features: Record<string, boolean>;
  onChange: (changes: Partial<FormState>) => void;
}

export default function CustomFieldFormClasses({ customField, features, onChange }: Props) {
  function handleChange(classFlags: ClassFlags) {
    if (classFlags.contact && !customField.classFlags.contact) {
      classFlags.comp = false;
      classFlags.deal = false;
      classFlags.property = false;
    } else if (classFlags.comp || classFlags.deal || classFlags.property) {
      classFlags.contact = false;
    }

    onChange({ classFlags });
  }

  return (
    <ManagedFormGroup
      checkboxClassName="my-0 mr-5"
      inputClassName="d-flex"
      label="Record Types"
      options={getClassFlagOptions(features)}
      required
      type="checkboxGroup"
      value={customField.classFlags}
      onValueChange={handleChange}
    />
  );
}
